import React from "react"
import './chipWord.scss'

export default class ChipWord extends React.Component {
    render() {
        const {
            name,
            onClick
        } = this.props;

        return(
            <span className={'chip-word'} onClick={onClick}>{name}</span>
        )
    }
}
